// src/config/api.tsx
type ApiConfig = {
  protocol: "http" | "https";
  host: string;
  port?: number;
  baseUrl: string;
};

// CRA replaces direct process.env references when it builds the browser bundle.
const CRA = process.env;

const protocol = (CRA.REACT_APP_API_PROTOCOL ?? "http") as
  | "http" | "https";

const portStr = CRA.REACT_APP_API_PORT;
const port = portStr ? Number(portStr) : 3005;
const host = CRA.REACT_APP_API_HOST ?? "localhost";
const configuredBase = CRA.REACT_APP_API_BASE?.trim();
const isProduction = CRA.NODE_ENV === "production";

if (isProduction && configuredBase !== "/api") {
  throw new Error("Production API base must be /api");
}

const rawOverride = configuredBase || `http://127.0.0.1:${port}`;

// ทำให้เป็น absolute เสมอ
const baseUrl =
  rawOverride.startsWith("http")
    ? rawOverride
    : (typeof window !== "undefined"
        ? `${window.location.origin}${rawOverride.replace(/\/$/, "")}`
        : `${protocol}://${host}${port ? `:${port}` : ""}${rawOverride.replace(/\/$/, "")}`);

export const apiConfig: ApiConfig = { protocol, host, port, baseUrl };

export function apiUrl(path: string): string {
  const base = apiConfig.baseUrl.endsWith("/") ? apiConfig.baseUrl : `${apiConfig.baseUrl}/`;
  return new URL(path.replace(/^\//, ""), base).toString();
}
